<div *ngIf="requestState">
    <app-no-data-message *ngIf="!hasData"></app-no-data-message>
    <div class="table-container table-fixed-header" *ngIf="hasData">
        <table
            class="table table-responsive table-hover table-sm"
            aria-label="table-widget"
        >
            <thead>
                <tr>
                    <th *ngFor="let head of tableView.headers">{{ head }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let body of tableView.dataset">
                    <td *ngFor="let item of body">{{ item }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
